<template>
  <div>
    <el-tree
      :data="data"
      show-checkbox
      node-key="id"
      :props="props"
      :node-key="props.value"
      default-expand-all
      ref="currentTree"
      @check-change="handleCheckChange">
    </el-tree>

  </div>
</template>

<script>

import api from "@/api/new/training.js";


export default {
  name: "ChapterLayout",
  props: {
    // 培训课程id
    trainingProgramId: {
      type: String,
      default: () => {
        return ''
      }
    },
    checkedKeys: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      data: [],
      props: {
        value: 'id',              // ID字段名
        label: 'dataName',         // 显示名称
        children: 'children'    // 子级字段名
      }
    };
  },
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      this.$emit("check-change", {checkedKeys: this.$refs.currentTree.getCheckedKeys()});
    }
  },
  mounted() {
    api.queryTrainingResourcesDataByTrainingProgramId({trainingProgramId: this.trainingProgramId}).then(res => {
      if (res.code == 0) {
        this.data = res.data;
        console.log('current tree %o',   this.$refs.currentTree)
        this.data.forEach(item => {
            this.checkedKeys.push(item.id)
        });
        this.$refs.currentTree.setCheckedKeys(this.checkedKeys);
      } else {
        this.$message.error(res.message);
      }
    });
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/chapterLayout.vue